





































	import AbpBase from "../../../lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  GetAssayCategoryList,
  GetAssayCategoryItemList,
  DeleteAssayCategory,
  DeleteAssayCategoryItem,
  GetAssayCategoryGroupList
} from "../../../api/basicDictionary";
import addOrEditCate from "./addOrEditCate.vue";
import addOrEditItem from "./addOrEditItem.vue";
import assayCategoryGroup from "./assayCategoryGroup.vue";

@Component({
  components: { addOrEditCate, addOrEditItem, assayCategoryGroup }
})
export default class extends AbpBase {
  currentCategory: any = null; //当前选中的化验大类
  cateLoading: boolean = false;
  itemLoading: boolean = false;
  addOrEditCateShow: boolean = false;
  addOrEditItemShow: boolean = false;
  addOrEditCateData: any = {};
  addOrEditItemData: any = {};
  cateData: any = [];
  groupShow = false;
  groupName="";
  cateColumns = [
    {
      title: "大类名称",
      key: "name",
      minWidth: 120,
    },
    {
      title: "分组",
      key: "groupName",
      width: 140,
    },
    {
      title: "序号",
      key: "sort",
      width: 70,
    },
    {
      title: "可删除",
      key: "isCanDelete",
      width: 90,
      render: (h: any, p: any) => {
        return h("span", p.row.isCanDelete ? "是" : "否");
      },
    },
    {
      title: "操作",
      width: 150,
      render: (h: any, p: any) => {
        let buttons = [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  this.updateCate(p.row);
                },
              },
            },
            "修改"
          ),
        ];
        if (p.row.isCanDelete) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.deleteCate(p.row);
                  },
                },
              },
              "删除"
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];

  itemData: any = [];
  itemColumns = [
    {
      title: "指标编码",
      key: "itemCode",
      width: 120,
    },
    {
      title: "指标名称",
      key: "itemName",
      minWidth: 120,
    },
    {
      title: "助记码",
      key: "helpCode",
      minWidth: 120,
    },
    {
      title: "参考值",
      key: "otherValue",
      width: 150,
    },
    {
      title: "单位",
      key: "unit",
      width: 120,
    },
    {
      title: "可删除",
      key: "isCanDelete",
      width: 90,
      render: (h: any, p: any) => {
        return h("span", p.row.isCanDelete ? "是" : "否");
      },
    },
    {
      title: "操作",
      width: 160,
      render: (h: any, p: any) => {
        let buttons = [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  this.updateItem(p.row);
                },
              },
            },
            "修改"
          ),
        ];
        if (p.row.isCanDelete) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.deleteItem(p.row);
                  },
                },
              },
              "删除"
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];

  addCate() {
    this.addOrEditCateData = {
      mode: "add",
    };
    this.addOrEditCateShow = true;
  }

  updateCate(row: any) {
    this.addOrEditCateData = {
      mode: "edit",
      item: row,
    };
    this.addOrEditCateShow = true;
  }

  deleteCate(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteAssayCategory(row);
        this.getCateList();
      },
    });
  }

  addItem() {
    if (!this.currentCategory) {
      return;
    }
    this.addOrEditItemData = {
      mode: "add",
      categoryId: this.currentCategory.id,
    };
    this.addOrEditItemShow = true;
  }

  updateItem(row: any) {
    if (!this.currentCategory) {
      return;
    }
    this.addOrEditItemData = {
      mode: "edit",
      item: row,
    };
    this.addOrEditItemShow = true;
  }

  deleteItem(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteAssayCategoryItem(row);
        this.getItemList();
      },
    });
  }

  async getCateList() {
    this.cateLoading = true;
    let res = await GetAssayCategoryList({ groupName: this.groupName});
    this.cateLoading = false;
    this.cateData = res.objects;
  }

  async getItemList() {
    if (!this.currentCategory) {
      return;
    }
    this.itemLoading = true;
    let res = await GetAssayCategoryItemList({
      categoryId: this.currentCategory.id,
    });
    this.itemLoading = false;
    this.itemData = res.objects;
  }

  handleCateClick(row: any) {
    this.currentCategory = row;
    this.getItemList();
  }

  created() {
    this.getGroupList();
    this.getCateList();
  }

  groupEdit() {
    this.groupShow = true;
  }
  groupList: any = [];
  async getGroupList() {
      let res = await GetAssayCategoryGroupList();
      this.groupList = res.objects;
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayCategory/index.vue